// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"2aa08b0c","656":"2aa08b0c"}[chunkId] + ".chunk.css";
};